import { putFormJSON } from 'bv-fetch';

export const submitPreferences = (content) => putFormJSON('/betting_settings', content);
